module.exports = __webpack_public_path__ + "img/15_dana_h.a8404531.png";